// #region date
export const DATE_INVALID_FORMAT = 'Bitte gib ein gültiges Datum im Format tt.mm.jjjj ein.';
export const DATE_INVALID_DAY = 'Bitte gib einen gültigen Tag an.';
export const DATE_PURCHASE_TOO_LATE = 'Das Kaufdatum darf nicht in der Zukunft liegen.';
export const DATE_PURCHASE_TOO_EARLY = 'Das Kaufdatum darf nicht länger als sechs Monate zurück liegen.';
// #endregion

// #region price
export const PRICE_UP_TO_1500 = 'Bitte gib einen Betrag zwischen € 1 und € 1500 ein.';
export const PRICE_UP_TO_2500 = 'Bitte gib einen Betrag zwischen € 1 und € 2500 ein.';
export const PRICE_UP_TO_10000 = 'Bitte gib einen Betrag zwischen € 1 und € 10.000 ein.';
// #endregion

// #region contract
export const CONTRACT_START_TOO_EARLY = 'Der Vertragsbeginn darf nicht vor dem heutigen Tag liegen.';
// #endregion

// #region title
export const TITLE_REQUIRED = 'Bitte gib die Anrede ein.';
// #endregion

// #region name
export const NAME_REQUIRED = 'Bitte gib einen Namen an.';
export const NAME_TOO_SHORT = 'Der Name muss mindestens 2 Zeichen lang sein.';
export const NAME_TOO_SHORT_3 = 'Der Name muss minestens 3 Zeichen lang sein.';
// #endregion

// #region street
export const STREET_REQUIRED = 'Bitte gib die Straße und Hausnummer ein.';
export const STREET_TOO_SHORT = 'Straße und Hausnummer muss mindestens 3 Zeichen lang sein.';
// #endregion

// #region zip
export const ZIP_REQUIRED = 'Bitte gib die Postleitzahl ein.';
export const ZIP_PATTERN = 'Bitte gib eine gültige Postleitzahl an.';
// #endregion

// #region city
export const CITY_REQUIRED = 'Bitte gib die Stadt ein.';
export const CITY_TOO_SHORT = 'Städtenamen müssen mindestens 2 Zeichen lang sein.';
// #endregion

// #region phone
export const PHONE_REQUIRED = 'Bitte gib deine Telefonnummer ein.';
export const PHONE_INVALID = 'Bitte gib eine gültige Telefonnummer ein.';
// #endregion

// #region company
export const COMPANY_REQUIRED = 'Bitte gib die Schule, Verein oder Firma ein.';
export const COMPANY_TOO_SHORT = 'Schule/Verein/Firma Namen müssen mindestens 3 Zeichen lang sein.';
// #endregion

// #region mail
export const MAIL_REQUIRED = 'Bitte gib eine E-Mail-Adresse an.';
export const MAIL_INVALID = 'Bitte gib eine gültige E-Mail-Adresse an.';
// #endregion

// #region insurance number
export const INSURANCE_NO_REQUIRED = 'Bitte gib deine Versicherungsnummer an.';
// #endregion

// #region password
export const PASSWORD_REQUIRED = 'Bitte gib dein Passwort ein.';
export const PASSWORD_TOO_SHORT = 'Das Passwort muss mindestens 8 Zeichen lang sein.';
export const PASSWORD_AGAIN_REQUIRED = 'Bitte wiederhole die Eingabe deines Passworts.';
export const PASSWORD_AGAIN_NO_MATCH = 'Die Passwörter stimmen nicht überein.';
// #endregion

// #region message
export const MESSAGE_REQUIRED = 'Bitte gib eine Nachricht ein.';
export const MESSAGE_TOO_SHORT = 'Die Nachricht muss mindestens 3 Zeichen lang sein.';
// #endregion

// #region state
export const STATE_REQUIRED = 'Bitte wähle ein Bundesland aus.';
// #endregion

// #region mail
export const MODEL_REQUIRED = 'Bitte gib das Modell und die Speicherkapazität an.';
export const MODEL_TOO_SHORT = 'Das Modell und die Speicherkapazität müssen mindestens 3 Zeichen lang sein..';

// #endregion

// #region manufacturer
export const MANUFACTUREUR_REQUIRED = 'Bitte gib einen Hersteller an.';
export const MANUFACTUREUR_TOO_SHORT = 'Hersteller müssen mindestens 3 Zeichen land sein.';
// #endregion

// #region devicetype
export const DEVICE_TYPE_REQUIRED = 'Bitte gib eine Gerätetyp an.';
// #endregion

// #region bank
export const NAME_OF_BANK_REQUIRED = 'Bitte gib ein Kreditinstitut an.';
export const NAME_OF_BANK_TOO_SHORT = 'Das Kreditinstitut muss mindestens 3 Zeichen lang sein.';
// #endregion

// #region iban
export const IBAN_REQUIRED = 'Bitte gib eine gültige IBAN an.';
export const IBAN_INVALID = 'Bitte gib eine gültige IBAN an.';
export const IBAN_CHECKSUM = ' Die Prüfsumme ist ungültig. Bitte gib eine gültige IBAN an.';
export const IBAN_BANK_CODE = 'Die Bankleitzahl ist ungültig. Bitte gib eine gültige IBAN an.';
export const IBAN_PATTERN = 'Die eingegebene IBAN erfüllt nicht die landesspezifischen Anforderungen.';
export const IBAN_NO_COUNTRY_CODE = 'Eine IBAN mit diesem Ländercode ist nicht zulässig.';
// #endregion

// #region BIC
export const BIC_REQUIRED = 'Bitte gib für ein Konto aus dem Ausland eine BIC an.';
export const BIC_PATTERN = 'Eine BIC muss mit 6 Buchstaben beginnen, gefolgt von 2 oder 5 alphanummerischen Zeichen.';
// #endregion

// #region accountHolder
export const ACCOUNT_HOLDER_TOO_SHORT = 'Der Kontoinhaber muss mindestens 3 Zeichen lang sein.';
export const ACCOUNT_HOLDER_REQUIRED = 'Bitte gib einen Kontoinhaber an.';
// #endregion
